import React from "react";
import Tab from "@components/tabs";
import StoreList from "./StoreList";

const StoreModal = ({ categoryId, moduleId }) => {
  const items = [
    {
      label: "Popular",
      component: StoreList,
      props: { type: "Popular", categoryId, moduleId },
    },
    {
      label: "Featured",
      component: StoreList,
      props: { type: "Featured", categoryId, moduleId },
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h3 style={{ marginBottom: "5px", fontSize: "18px", fontWeight: "600" }}>
        Store List {categoryId ? `(Category: ${categoryId})` : ""}
      </h3>
      <p style={{ marginBottom: "15px", color: "#666", fontSize: "13px" }}>
        Select stores in the order you want them to appear (1st selected = Rank
        1, 2nd = Rank 2, etc.). Deselect and reselect to change the order.
      </p>
      <Tab items={items} fitContent paramKey="type" />
    </div>
  );
};

export default StoreModal;
